module.exports = __webpack_public_path__ + "img/311.3d11d857.jpg";